export const UPLOAD_CREATIVES_LIMIT = 30;

/** Flip to `false` to run the X creatives list and settings update on the real API while developing. */
export const USE_MOCK_API = false;

/** `true`: those calls run on mock data. Always `false` in a production build, whatever the flag above says. */
export const DEV_MODE = USE_MOCK_API && process.env.NODE_ENV !== 'production';
